import Link from 'next/link';
import { memo } from 'react';

import { Close } from '@air/next-icons';
import { ActionSheet } from '@air/primitive-action-sheet';
import { Button } from '@air/primitive-button';
import { IconButton } from '@air/primitive-icon-button';

import { TryCanvasPopoverVideos } from '~/components/TryCanvasPopover/TryCanvasPopoverVideos';

export type TryCanvasPopoverMobileProps = {
  onClose: () => void;
};

export const TryCanvasPopoverMobile = memo(({ onClose }: TryCanvasPopoverMobileProps) => {
  return (
    <ActionSheet onClose={onClose} className="bg-gray-1" data-testid="TRY_CANVAS_POPOVER_MOBILE">
      <div className="relative aspect-[360/202] rounded-t-8">
        <TryCanvasPopoverVideos />
        <div className="pointer-events-none absolute right-0 bottom-0 left-0 h-16 bg-gradient-to-t from-black/10 to-transparent dark:from-white/5" />
        <IconButton
          className="absolute top-3 right-3"
          size="small"
          appearance="ghost"
          color="grey"
          icon={Close}
          label="Close"
          onClick={onClose}
        />
      </div>
      <div className="flex flex-col gap-4 px-8 pt-4 pb-6">
        <p className="font-semibold text-24 text-gray-12">Introducing Canvas</p>
        <p className="text-14 text-gray-11">A brand new way to edit and scale—all in one place.</p>
        <p className="text-14 text-gray-11">
          Canvas is available on desktop. Visit{' '}
          <Link href="https://air.inc" target="_blank" rel="noopener noreferrer">
            air.inc
          </Link>{' '}
          on your computer to get started.
        </p>
        <div className="flex justify-end">
          <Button appearance="outline" color="grey" onClick={onClose} size="large">
            Got it
          </Button>
        </div>
      </div>
    </ActionSheet>
  );
});

TryCanvasPopoverMobile.displayName = 'TryCanvasPopoverMobile';
